export const LOGIN_PATH = '/login';
export const NO_PERMISSION_PATH = '/no-permission';
export const GRANT_ACCESS_PATH = '/grant-access';
export const REQUEST_ACCESS_PATH = '/request-access';
